import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./index.css";
import PastProcedures from "./past-procedures/PastProcedures";

const router = createBrowserRouter([
  {
    path: "/",
    element: <PastProcedures />,
  },
]);

ReactDOM.createRoot(
  document.getElementById("root") as ReactDOM.Container
).render(
  <React.StrictMode>
    <head>
      <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" />
      <link
        href="https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200..1000;1,6..12,200..1000&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap"
        rel="stylesheet"
      />
      <style>
        {`
          html {
            font-size: 100%;
          }

          body {
            font-family: "Nunito Sans", sans-serif;
          }
        `}
      </style>
    </head>
    <RouterProvider router={router} />
  </React.StrictMode>
);
